<script lang="ts">
  import BankWithdraw from "$lib/components/ModalContents/DepositWithdraw/Withdraw/BankWithdraw.svelte";
  import CryptoWithdraw from "$lib/components/ModalContents/DepositWithdraw/Withdraw/CryptoWithdraw.svelte";
  import BankIcon from "$lib/icons/BankIcon.svelte";
  import {toasts} from "$lib/stores/toastStores";
  import {user} from "$lib/stores";
  import {openDialog} from "$lib/stores/dialogStores";


  let withdrawType: null | 'bank' | 'crypto' = $state(null);

  function setWithdrawType(type: 'bank' | 'crypto') {
    if (type === 'bank') {
      if(!$user?.miniKycPassed) {
        openDialog('MiniKYCModal');
        return toasts.send('Please complete your Personal Information before making a withdrawal', 'info');
      }
    }
    withdrawType = type;
  }

  function scrollToActive(target:any, type: 'bank' | 'crypto') {
    setWithdrawType(type);
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });
  }
</script>

<div class="bg-primary-dark p-2 md:p-4 rounded-2xl gap-2 md:gap-5 w-full {withdrawType ?'flex flex-nowrap overflow-x-scroll':'grid grid-cols-2 lg:grid-cols-3'}">
  <button onclick={(e) => scrollToActive(e.target, 'bank')} class="text-center overflow-hidden border-2 transition-all duration-200 min-w-36 {withdrawType ? 'flex-shrink-0' : 'col-span-1'}  {withdrawType === 'bank' ? 'border-2 border-primary-fire rounded-lg' : 'border-transparent'}">
    <div class="bg-white p-2 h-16 flex items-center justify-around rounded">
      <BankIcon />
    </div>
    <h5 class="text-xs md:text-sm py-2">Bank Transfer</h5>
  </button>
  <button onclick={(e) => scrollToActive(e.target, 'crypto')} class="text-center overflow-hidden border-2 transition-all duration-200 min-w-36 {withdrawType ? 'flex-shrink-0' : 'col-span-1'}  {withdrawType === 'crypto' ? 'border-2 border-primary-fire rounded-lg' : 'border-transparent'}">
    <div class="bg-white p-2 h-16 flex items-center justify-around rounded">
      <img src="/currencies/bitcoin.png" class="w-10" alt="Forza.bet - Bitcoin casino">
      <img src="/currencies/ethereum.png" class="w-10" alt="Forza.bet - Ethereum casino">
      <img src="/currencies/trx.png" class="w-10 hidden lg:block" alt="Forza.bet - Tron casino">
    </div>
    <h5 class="text-xs md:text-sm py-2">Cryptocurrency</h5>
  </button>
</div>

{#if (withdrawType === 'bank')}
  <BankWithdraw />
{:else if (withdrawType === 'crypto')}
  <CryptoWithdraw />
{:else}
  <div class="bg-primary-dark p-2 md:p-4 rounded-2xl w-full mt-2">
    <h5 class="text-white text-center">Please select a withdrawal method</h5>
  </div>
{/if}
